// extracted by mini-css-extract-plugin
module.exports = {"root":"DesktopEmptyState_root__Gf2kv","icon":"DesktopEmptyState_icon__5ao1B","text":"DesktopEmptyState_text__dR2AZ"};